import { Subject, Observable } from 'rxjs';

export class ModalFactory {
	private subjects = new Map<string, Subject<any>>();
	private observables = new Map<string, Observable<any>>();
	createModal<T>(name: string): { 
		subject: Subject<T>; 
		observable: Observable<T>;
		set: (value: T) => void;
	} {
		if (this.subjects.has(name)) {
			const subject = this.subjects.get(name)!;
			const observable = this.observables.get(name)!;
			return {
				subject,
				observable,
				set: (value: T) => subject.next(value),
			};
		}

		const subject = new Subject<T>();
		const observable = subject.asObservable();
		
		this.subjects.set(name, subject);
		this.observables.set(name, observable);

		return { 
			subject, 
			observable,
			set: (value: T) => subject.next(value),
		};
	}
}